import Layout from "@/components/Layout";
import Input from "@/components/Tags/Input";
import { Checkbox, FormControlLabel, IconButton, InputAdornment } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import Image from "next/image";
import { ucwords } from "@/components/Ucwords";

const MapLinks = ({branch}) =>{
    const [showGoogleMap,  setShowGoogleMap] = useState(null);
    const [latLong, setLatLong] = useState(false);
    useEffect(()=>{
        if(!branch) return;
        if(parseFloat(branch.lat) <= 0) setLatLong(false);
        else setLatLong(true);
    },[branch]);
    return(
        <div className="relative">
            <div className="relative flex flex-row-reverse">
                {branch?.map_embeded_link && (
                    <button
                        type="button"
                        className={`w-10 h-9 transition-all ${(showGoogleMap ==  branch.id) ? 'grayscale' : 'grayscale-0'}`}
                        onClick={()=>{
                            if(showGoogleMap ==  branch.id){
                                setShowGoogleMap(null);
                            }
                            else{
                                setShowGoogleMap(branch.id);
                            }
                        }}
                    >
                        <Image
                            src={"/assets/images/google-maps.webp"}
                            alt="google-map-icon"
                            layout='responsive'
                            height={150}
                            width={150}
                        />
                    </button>
                )}
                {latLong && (
                    <a
                        target="_blank" href={`https://waze.com/ul?q=${branch.short_name}&ll=${branch.lat},${branch.long}&navigate=yes&z=10`} rel="noopener noreferrer"
                        disabled={(!branch.lat && !branch.long)}
                        className={`cursor-pointer drop-shadow-md hover:contrast-200 mr-2 w-10 h-10 transition-all ${(branch.lat && branch.long) ? '' : 'cursor-default'}`}
                    >
                        <Image
                            src={"/assets/images/waze.svg"}
                            alt="waze-icon"
                            layout='responsive'
                            height={150}
                            width={150}
                        />
                    </a>
                )}
                {latLong && (
                    <a
                        target="_blank" href={`http://maps.apple.com/?q=${branch.name}&ll=${branch.lat},${branch.long}&z=19&t=r&sspn=50.0,50.0`} rel="noopener noreferrer"
                        disabled={(!branch.lat && !branch.long)}
                        className={`cursor-pointer drop-shadow-md hover:contrast-200 mr-2 w-10 h-10 transition-all ${(branch.lat && branch.long) ? '' : 'cursor-default'}`}
                    >
                        <Image
                            src={"/assets/images/apple-map.webp"}
                            alt="apple-map-icon"
                            layout='responsive'
                            height={150}
                            width={150}
                        />
                    </a>
                )}
            </div>
            {(branch?.map_embeded_link && (showGoogleMap ==  branch.id)) && (
                <div
                    className='relative w-full h-96 mt-2'
                    dangerouslySetInnerHTML={{
                        __html: branch.map_embeded_link,
                    }}></div>
            )}
        </div>
    );
};

export default function BranchLocator({ branches }){
    const [filteredBranch, setFilteredBranch] = useState(null);
    const [loadingSearch, setLoadingSearch] = useState(null);
    const [filterMsg, setFilterMsg] = useState(null);
    const [provinces, setProvinces] = useState([]);
    const [branchCb, setBranchCb] = useState(null);

    const handleChangeBranch = async (event) => {
        let bCbm = document.querySelectorAll(`[name="branch"]`);
        let tempCbArr = [];
        let checkedBranch = [];
        bCbm.forEach((item, i) => {
            tempCbArr[item.value] = item.checked;
            if(item.checked) checkedBranch.push(item.value);
        });
        setBranchCb(tempCbArr);
        if(checkedBranch.length > 0){
            const filteredBr = await branches?.filter((b) => checkedBranch.includes(b.PROV_NAME));
            if(filteredBr.length > 0){
                setFilteredBranch(filteredBr);
                setFilterMsg(null);
                const sb = document.querySelector("#searchBranch").value;
                if(sb.length > 0) searchBranch(sb, filteredBr);
            }
            else{
                setFilterMsg('No branch found.');
                setFilteredBranch(null);
            }
        }
        else{
            const sb = document.querySelector("#searchBranch").value;
            if(sb.length > 0) searchBranch(sb);
            else setFilteredBranch(branches);
        }
    };

    const debounce = (func) => {
        let timer;
        return function (...args) {
            const context = this;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                timer = null;
                func.apply(context, args);
            }, 200);
        };
    };

    const searchBranch = async (q, fBranch = null) => {

        let bCbm = document.querySelectorAll(`[name="branch"]`);
        let checkedBranch = [];
        bCbm.forEach((item, i) => {
            if(item.checked) checkedBranch.push(item.value);
        });
        if(q.length > 0){
            setLoadingSearch(true);
            const text = q.trim().replace(/[\W_]+/g, '');
            let currentBranches = checkedBranch.length > 0 ? filteredBranch : branches;
            if(fBranch) currentBranches = fBranch;
            let filteredBr =  await currentBranches?.filter((b) => b.name.toLowerCase().includes(text.toLowerCase()));
            if(filteredBr?.length > 0){
                setFilteredBranch(filteredBr);
                setFilterMsg(null);
            }
            else{
                setFilterMsg('No branch found.');
                setFilteredBranch(null);
            }
            setLoadingSearch(false);
        }
        else{
            if(checkedBranch.length <= 0) setFilteredBranch(branches);
            else handleChangeBranch();
            setLoadingSearch(false);
            setFilterMsg(null);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    //const optimizedFnBranch = useCallback(debounce(searchBranch),[filteredBranch]);

    useEffect(()=>{
        if(!branches) return;
        setFilteredBranch(branches);
        let arrProv = [];
        branches.map((branch, index) => {
            const totalBranch = branches.filter((b) => b.PROV_NAME.includes(branch.PROV_NAME));
            arrProv.push({label: ucwords(branch.PROV_NAME), value: branch.PROV_NAME, is_default: branch.is_default, total: totalBranch.length});
        });
        const removeDuplicateArrProv = arrProv.filter((value, index) => {
            const temp_value = { label: value.label, value: value.value, total: value.total};
            const _value = JSON.stringify(temp_value);
            return index === arrProv.findIndex(obj => {
                const temp_obj = { label: obj.label, value: obj.value, total: obj.total};
                return JSON.stringify(temp_obj) === _value;
            });
        });
        setProvinces(removeDuplicateArrProv);
        let bArr = [];
        removeDuplicateArrProv.forEach((item, i) => {
            let p = item.value;
            bArr[p] = false;
        });
        setBranchCb(bArr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[branches]);
    return(
        <Layout pageTitle={`Rapidé - Branch Locator`}>
            <div className="relative top-0 max-w-full mx-auto lg:mt-0 md:mt-0 sm:mt-[93px] mt-[93px]">
                <div className="relative lg:h-[150px] md:h-[110px] sm:h-[101px] h-[93px] bg-black"></div>
                <div className="max-w-screen-xl mx-auto py-4 px-2">
                    <h1 className="py-2 mb-4 text-center text-5xl underline underline-offset-1 decoration-rapide-yellow">Branch Locator</h1>
                    <div className="flex sm:flex-row flex-col sm:gap-16 gap-6 mt-2 sm:px-8 px-2">
                        <div className="flex flex-col sm:w-[300px] w-full">
                            <Input
                                className="!mb-1"
                                fullWidth
                                size="small"
                                id="searchBranch"
                                name="searchBranch"
                                type="text"
                                label=""
                                variant="outlined"
                                placeholder={`Search branch`}
                                onChange={(e, val)=>{
                                    searchBranch(e.target.value);
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="clear search"
                                                        onClick={(e)=>{
                                                            document.querySelector("#searchBranch").value = "";
                                                            searchBranch("");
                                                        }}
                                                        edge="end"
                                                        >
                                                            <ClearIcon fontSize="small"/>
                                                    </IconButton>
                                                </InputAdornment>,
                                }}
                            />
                            <h1 className="text-gray-400 text-lg border-b my-4 border-gray-200">BRANCH LOCATION</h1>
                            <div>
                                {provinces?.map((p, index)=>{
                                    return(
                                        <div className="flex flex-row justify-between items-center align-middle group/cb transition-all" key={index}>
                                            <label className='text-sm pb-px cursor-pointer group-hover/cb:text-rapide-red' htmlFor={'i-'+p.value}>
                                                <span className={`${branchCb[p.value] && 'text-rapide-red'} font-semibold tracking-wide`}>{p.label}</span>
                                                <span className="text-gray-400 ml-1">({p.total})</span>
                                            </label>
                                            <Checkbox
                                                className="py-1"
                                                onChange={()=>handleChangeBranch()}
                                                value={p.value}
                                                checked={branchCb[p.value]}
                                                name={`branch`}
                                                size='small'
                                                id={'i-'+p.value}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <ul className="w-full divide-y divide-gray-200">
                            {loadingSearch && (
                                <li>Loading...</li>
                            )}
                            {filterMsg && (
                                <li>{filterMsg}</li>
                            )}
                            {filteredBranch?.map((branch, index)=>{
                                return(
                                    <li key={index} className="py-1">
                                        <h1 className="text-lg font-bold">{branch.name}</h1>
                                        <div className="px-4">
                                            <p className="text-gray-500 font-medium">{branch.description}</p>
                                            <p className="text-gray-700 font-medium">{branch.CITY_NAME}, {branch.PROV_NAME}</p>
                                            <p className="text-gray-500 font-medium">{branch.contact_no}</p>
                                            <p className="italic">{branch.email}</p>
                                        </div>
                                        <MapLinks branch={branch} />
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export async function getServerSideProps(context) {

    let branches = [];
    try {
        const getBranches = await fetch(`${process.env.API_URL}/all_branches`);
        branches = await getBranches.json();
    } catch (error) {
        console.log(error);
    }
    return {
        props: {
            branches,
        },
    }
}